function messageAlertTooltip(_, integrationConstant, gettextCatalog, $timeout) {
    const vm = this;
    let initialStateToggle;
    const HIDE_MESSAGE_MILISECONDS = 7000;

    const isMerchantAdminLocation = () => vm.location === integrationConstant.LOCATION.merchantAdmin.label;
    const manageInitialStateForToggle = (parentState) => {
        return isMerchantAdminLocation() &&
            parentState.posType !== integrationConstant.POS_TYPE.Demo &&
            parentState.toggle !== initialStateToggle;
    };

    const manageMessage = (initialStateParent) => {

        const customMessage = initialStateParent.toggle ?
            gettextCatalog.getString("Are you sure you want to enable this functionality? By doing this action this functionality will be available to your customer in the Qkr App") :
            gettextCatalog.getString("Are you sure you want to disable this functionality? By doing this action this functionality won\'t be available to your customer in the Qkr App");

        return customMessage;
    };
    vm.$onInit = () => {
        vm.mssTooltipPlace = vm.mssTooltipPlace || 'top-left';
        // keep state for specific situation
        /* eslint-disable fp/no-mutation */
        if (vm.initialStateData) {
            initialStateToggle = _.assign(vm.initialStateData.toggle);
        }
    };
    vm.$onChanges = (changesObj) => {
        const hasChanged = (currentValue, previousValue) => {
            // some checks failed I have to use currentValue === undefined
            if (currentValue === undefined ||
                currentValue.toggle === undefined ||
                previousValue === undefined ||
                previousValue.toggle === undefined) {
                return false;
            }
            return currentValue.toggle !== previousValue.toggle;
        };
        const currentValue = changesObj.initialStateData ?
            changesObj.initialStateData.currentValue : undefined;
        const previousValue = changesObj.initialStateData ?
            changesObj.initialStateData.previousValue : undefined;

        // only for change toggle state
        if (hasChanged(currentValue, previousValue)) {
            const parentState = currentValue;
            vm.isMssTooltipDisplay = manageInitialStateForToggle(parentState);
            vm.mssTooltipMessage = manageMessage(parentState);
        }
        const makeSureTimeoutWillExecute = () => {
            // to avoid timeout if there isn't previous values
            if (vm.isMssTooltipHideAfterTime) {
                // hide the message tooltip after a few seconds
                $timeout(() => {
                    vm.isMssTooltipDisplay = false;
                }, HIDE_MESSAGE_MILISECONDS);
            }
        };
        makeSureTimeoutWillExecute();
    };
}
angular.module('qkr.integration.settings')
    .component('messageAlertTooltip', {
        template: require('./message-alert-tooltip.html'),
        bindings: {
            initialStateData: '<?',
            isMssTooltipDisplay: '<',
            mssTooltipMessage: '<?',
            location: '<?',
            isMssTooltipHideAfterTime: '<?',
            mssTooltipPlace: '<?'
        },
        controller: messageAlertTooltip,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./src/integration-settings/components/common/message.alert.tooltip.component.js